module.exports = __webpack_public_path__ + "static/media/AoA_RaceGameEnvShot_14.a413daa5.jpg";